export default "__VITE_ASSET__CsKHCjBg__"